export default {
  pageDescription: {
    id: 'policies_and_eligible_insurances_page_description',
    defaultMessage: 'Check plans and warranties here',
  },
  eligibleDevices: {
    id: 'policies_and_eligible_insurances_eligible_devices',
    defaultMessage: 'Eligible devices',
  },
  yourProtectionPlans: {
    id: 'policies_and_eligible_insurances_your_protection_plans',
    defaultMessage: 'Your Protection Plans',
  },
  updatePaymentMethodDescription: {
    id: 'policies_and_eligible_insurances_update_payment_method_description',
    defaultMessage:
      'Protection Plan payment didn’t go through. Update your payment method to keep your device protected.',
  },
  updatePaymentMethodButton: {
    id: 'policies_and_eligible_insurances_update_payment_method_button',
    defaultMessage: 'Update payment method',
  },
}
